<!-- Originally we had ag-grid fixed height set to 300px, regardless of row number
To avoid empty space in bottom area, if row count is less than 8 (this fits in 300px), height is calculated automatically -->
<ag-grid-angular
  [domLayout]="referenceBookings.length > 8 ? 'normal' : 'autoHeight'"
  [style.height]="referenceBookings.length > 8 ? '300px' : 'none'"
  [gridOptions]="gridOptions"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  [components]="frameworkComponents"
  [suppressContextMenu]="true"
  (gridReady)="onGridReady($event)"
  (gridSizeChanged)="onGridSizeChanged($event)"
  class="ag-theme-alpine_customize"
  style="width: 100%"></ag-grid-angular>
@if (!referenceTableSumHidden) {
  <br />
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <div [style.width.px]="widthToAlignTotalAmount" class="row align-items-start">
      <div class="w-50">
        <label [style.display]="referenceTableSumHidden ? 'none' : 'block'">
          <b>{{ 'REFERENCED_BOOKING_SUM_AMOUNT' | translate }}</b>
        </label>
      </div>
      <div class="row w-50 justify-content-end">
        <label [ngClass]="{ 'red-characters': negativeTotalAmount() }">
          <b>{{ totalReferencedAmount }}</b>
        </label>
      </div>
    </div>
  </div>
}
